import React from "react";
import { Button, Col, Modal, Row, Table } from "antd";
import { sendNotifCursoLineaPend, sendNotifObsPendientes } from "../../../api/notifica";
import { MSN_GUARDAR } from "../../../utils/constanst";
import "./Notifica.scss";

export default function Acreditaciones(props) {
    const {acreditacion, setLoader, refresh, setRefresh, rolModulo, idProceso} = props;

    const confirmaEnvioObsPendientes = (event) => {
        event.preventDefault();
        Modal.confirm({
            title: <p>Se enviarán correos electrónicos a las/os Observadoras/es con observaciones pendientes por atender 
                en su solicitud.</p>,
            content: "¿Deseas continuar?",
            okText: "Continuar",
            cancelText: "Cancelar",
            onOk() {
                setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader
                enviaNotificacionObsPendientes();
            },
        });
    };

    function enviaNotificacionObsPendientes() {
        sendNotifObsPendientes(idProceso).then((res) => {
            if(res.data.code === 200) {
                setLoader({ loading: false, message: "" }); //Se desactiva el loader
                Modal.success({
                    content: res.data.message,
                    okText: "Aceptar",
                });
            } else {
                setLoader({ loading: false, message: "" }); //Se desactiva el loader
                Modal.error({
                    content: res.data.message,
                });
            }
            if(refresh) { //Para cargar de nuevo el contador 
                setRefresh(false);
            } else {
                setRefresh(true);
            }
        }).catch((error) => {
            console.log(error);
            setLoader({ loading: false, message: "" }); //Se desactiva el loader
            Modal.error({
                content: "Hubo un problema al invocar el servicio web.",
            });
        });
    }

    const confirmaEnvioCursoLineaPend = (event) => {
        event.preventDefault();
        Modal.confirm({
            title: <p>Se enviarán correos electrónicos a las/os Observadoras/es con curso virtual pendiente por concluir.</p>,
            content: "¿Deseas continuar?",
            okText: "Continuar",
            cancelText: "Cancelar",
            onOk() {
                setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader
                enviaNotificacionCursoLineaPend();
            },
        });
    };

    function enviaNotificacionCursoLineaPend() {
        sendNotifCursoLineaPend(idProceso).then((res) => {
            if(res.data.code === 200) {
                setLoader({ loading: false, message: "" }); //Se desactiva el loader
                Modal.success({
                    content: res.data.message,
                    okText: "Aceptar",
                });
            } else {
                setLoader({ loading: false, message: "" }); //Se desactiva el loader
                Modal.error({
                    content: res.data.message,
                });
            }
            if(refresh) { //Para cargar de nuevo el contador 
                setRefresh(false);
            } else {
                setRefresh(true);
            }
        }).catch((error) => {
            console.log(error);
            setLoader({ loading: false, message: "" }); //Se desactiva el loader
            Modal.error({
                content: "Hubo un problema al invocar el servicio web.",
            });
        });
    }

    const data = [
        {
            key: "1",
            descripcion: "Número de veces que se ha notificado a la ciudadanía",
            valor: acreditacion[0].notifEnviadas,
        },
        {
            key: "2",
            descripcion: "Solicitudes con observaciones por atender, con correo electrónico",
            valor: acreditacion[0].totalCuentas,
        },
    ];

    const columns = [
        {
            title: "Notificación para atender observaciones",
            colSpan: 2,
            dataIndex: "descripcion",
        },
        {
            title: "",
            colSpan: 0,
            dataIndex: "valor",
            render: (record) => (
                <><b>{record}</b></>
            ),
        },
    ];

    const data2 = [
        {
            key: "1",
            descripcion: "Número de veces que se ha notificado a la ciudadanía",
            valor: acreditacion[1].notifEnviadas,
        },
        {
            key: "2",
            descripcion: "Solicitudes por concluir el curso virtual",
            valor: acreditacion[1].totalCuentas,
        },
    ];

    const columns2 = [
        {
            title: "Notificación para concluir curso virtual",
            colSpan: 2,
            dataIndex: "descripcion",
        },
        {
            title: "",
            colSpan: 0,
            dataIndex: "valor",
            render: (record) => (
                <><b>{record}</b></>
            ),
        },
    ];
    
    return (
        <div>
            <Row>
                <Col span={24} style={{ fontSize:"16px" }}>
                    Notifica a la ciudadanía que cuenta con observaciones por atender en su solicitud para ser observador/a en
                    el <strong style={{color: "#D5067F"}}>{acreditacion[0].nombreProceso}</strong>.
                </Col>
            </Row>
            <br />
            <Row>
                <Col span={14}>
                    <Table dataSource={data} columns={columns} pagination={false} />
                </Col>
                <Col span={1} />
                <Col span={6}>
                    <Button type="primary" className="top70pxwidth180" disabled={rolModulo.consulta} 
                            onClick={confirmaEnvioObsPendientes}>
                        Enviar notificación
                    </Button>
                </Col>
            </Row>
            <br /><br />
            <Row>
                <Col span={24} style={{ fontSize:"16px" }}>
                    Notifica a la ciudadanía que cuenta con curso virtual pendiente por concluir en 
                    el <strong style={{color: "#D5067F"}}>{acreditacion[0].nombreProceso}</strong>.
                </Col>
            </Row>
            <br />
            <Row>
                <Col span={14}>
                    <Table dataSource={data2} columns={columns2} pagination={false} />
                </Col>
                <Col span={1} />
                <Col span={6}>
                    <Button type="primary" className="top70pxwidth180" disabled={rolModulo.consulta} 
                            onClick={confirmaEnvioCursoLineaPend}>
                        Enviar notificación
                    </Button>
                </Col>
            </Row>
        </div>
    );
}